import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * DELETE `/crm/customer-order/{id}`。
 * DRAFT **實體刪除**（非軟取消）；已有 Sales Order 引用時拒絕。
 * body：`updatedAt`（record；契約：除刪除外 commands 皆需版本；刪除亦帶樂觀鎖為佳）。
 */
export async function deleteDraftCustomerOrder(id, payload = {}) {
  const { data: raw } = await request.delete(
    `/crm/customer-order/${id}`,
    { data: keysToSnake(payload) },
  );
  return parseVer4DetailResponse(raw);
}
